import { PermissionType } from 'api/types/entity';
import { FormFooter, FormFooterCancel } from 'components';
import { useTranslation } from 'libs/i18n';
import { PermissionWrapper } from 'libs/permissions';
import { Submit, useFormContext } from 'modules/order/common/forms/orderForm';

export interface CreateOrderFormFooterProps {
  submitLoading: boolean | undefined;
  onBack: () => void;
}

export const CreateOrderFormFooter = ({
  submitLoading,
  onBack,
}: CreateOrderFormFooterProps) => {
  const { t } = useTranslation();
  const { dirty, submitDisabled } = useFormContext();

  return (
    <FormFooter visible>
      <FormFooterCancel label={t('common.back')} onClick={onBack} />
      <PermissionWrapper permissions={[PermissionType.Order_CreateOne]}>
        <Submit
          disabled={submitDisabled || !dirty}
          label={t('common.add')}
          loading={submitLoading}
          sizeVariant="m"
        />
      </PermissionWrapper>
    </FormFooter>
  );
};
